module.exports = __webpack_public_path__ + "img/www.trulia.com.aac057a2.png";